import { useEffect, useMemo, useState } from 'react';
import { useAppSelector } from '../../../../app/store/hooks';
import {
  formatLocalClock,
  toUserProfileView,
} from '../../application/mapUserProfile';
import { useGetProfileQuery } from '../../infrastructure/api/user.api';

export function useUserProfile() {
  const accessToken = useAppSelector((state) => state.authorization.accessToken);
  const storedProfile = useAppSelector((state) => state.user.profile);
  const { data, isLoading, isFetching, isError } = useGetProfileQuery(
    undefined,
    { skip: !accessToken },
  );

  const [clockLabel, setClockLabel] = useState(() => formatLocalClock());

  useEffect(() => {
    const tick = () => setClockLabel(formatLocalClock());
    tick();
    const timer = window.setInterval(tick, 30_000);
    return () => window.clearInterval(timer);
  }, []);

  const profile = data ?? storedProfile;
  const view = useMemo(() => toUserProfileView(profile), [profile]);

  return {
    profile,
    view,
    clockLabel,
    isLoading: Boolean(accessToken) && isLoading && !profile,
    isFetching,
    isError,
  };
}
